export default "__VITE_ASSET__BTeR1laY__"